export const templatePresets = [
  {
    src: "/Mememaker/template/template6.png",
    textFields: [
      {
        startPosition: {
          x: "50%",
          y: "40%",
        },
        width: "50%",
      },
    ],
  },
  {
    src: "/Mememaker/template/template8.png",
    textFields: [
      {
        startPosition: {
          x: "0%",
          y: "85%",
        },
        width: "100%",
      },
      {
        startPosition: {
          x: "0%",
          y: "50%",
        },
        width: "100%",
      },
      {
        startPosition: {
          x: "0%",
          y: "20%",
        },
        width: "100%",
      },
    ],
  },
  {
    src: "/Mememaker/template/template23.png",
    textFields: [
      {
        startPosition: {
          x: "63%",
          y: "73%",
        },
        width: "30%",
      },
      {
        startPosition: {
          x: "70%",
          y: "25%",
        },
        width: "30%",
      },
    ],
  },
  {
    src: "/Mememaker/template/template24.png",
    textFields: [
      {
        startPosition: {
          x: "50%",
          y: "73%",
        },
        width: "50%",
      },
      {
        startPosition: {
          x: "50%",
          y: "25%",
        },
        width: "50%",
      },
    ],
  },
  {
    src: "/Mememaker/template/template30.png",
    textFields: [
      {
        startPosition: {
          x: "0%",
          y: "75%",
        },
        width: "100%",
      },
    ],
  },
  {
    src: "/Mememaker/template/template36.png",
    textFields: [
      {
        startPosition: {
          x: "50%",
          y: "35%",
        },
        width: "40%",
      },
    ],
  },
  {
    src: "/Mememaker/template/template47.png",
    textFields: [
      {
        startPosition: {
          x: "10%",
          y: "65%",
        },
        width: "40%",
      },
      {
        startPosition: {
          x: "50%",
          y: "55%",
        },
        width: "40%",
      },
    ],
  },
  {
    src: "/Mememaker/template/template48.png",
    textFields: [
      {
        startPosition: {
          x: "10%",
          y: "65%",
        },
        width: "40%",
      },
      {
        startPosition: {
          x: "50%",
          y: "55%",
        },
        width: "40%",
      },
    ],
  },
];
